import { render } from "./PageContainer.vue?vue&type=template&id=215d6f2e&scoped=true"
const script = {}

import "./PageContainer.vue?vue&type=style&index=0&id=215d6f2e&scoped=true&lang=scss"

import exportComponent from "D:\\wamp\\www\\GSALT\\gsalt-matters-ibd-denmark\\web\\modules\\vuejs\\vuejs-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-215d6f2e"]])

export default __exports__